export const getStorageVisit = () => {
    return localStorage.getItem('visit') || ''
}

export const setStorageVisit = (visit: any) => {
    localStorage.setItem('visit', JSON.stringify(visit));
}